export const bookRoutes = [
  // 책 상세 페이지
  {
    path: '/app/book/:id',
    name: 'book-detail',
    component: () => import('@/views/BookDetailView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 메모 추가 페이지
  {
    path: '/app/book/:id/memo/add',
    name: 'memo-add',
    component: () => import('@/views/MemoAddView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 책 찾기 페이지
  {
    path: '/app/book-search',
    name: 'book-search',
    component: () => import('@/views/BookSearchView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 독서통장 페이지
  {
    path: '/app/bankbook',
    name: 'bankbook',
    component: () => import('@/views/BankBookView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 통계 페이지
  {
    path: '/app/stats',
    name: 'stats',
    component: () => import('@/views/StatsView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },

  // 독서 달력 페이지
  {
    path: '/app/reading-calendar',
    name: 'reading-calendar',
    component: () => import('@/views/ReadingCalendarView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 메모 페이지
  {
    path: '/app/memo',
    name: 'memo',
    component: () => import('@/views/MemoView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 내 서재 페이지
  {
    path: '/app/library',
    name: 'library',
    component: () => import('@/views/MyLibraryView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  }
]

